/**
 * Orbex macro categories.
 *
 * `keywords` and `order` are matching data: they are compared against macro
 * names that come from the backend, so they stay literal and are not
 * translated. Only the visible category title is a locale key, resolved from
 * the Orbex dashboard locale override (`ORBEX.MACROS.*`).
 */
export const macroCategories = [
  {
    key: 'technical',
    titleKey: 'ORBEX.MACROS.CATEGORIES.TECHNICAL',
    icon: 'i-lucide-monitor-cog',
    keywords: ['واحد فنی - '],
    order: [
      'رمز یکبار مصرف',
      'مشکل ورود',
      'سرور مجازی',
      'پلتفرم',
      'کپی ترید',
      'عدم نمایش حساب',
      'تغییر لول',
      'مشکل ایجاد حساب رویال',
    ],
  },
  {
    key: 'financial',
    titleKey: 'ORBEX.MACROS.CATEGORIES.FINANCIAL',
    icon: 'i-lucide-wallet-cards',
    keywords: ['واحد مالی - '],
    order: ['واریز', 'برداشت', 'بونوس', 'ریبیت', 'مشکل پرداخت'],
  },
  {
    key: 'identity',
    titleKey: 'ORBEX.MACROS.CATEGORIES.IDENTITY',
    icon: 'i-lucide-shield-check',
    keywords: ['واحد هویتی - '],
    order: [
      'احراز هویت',
      'تغییر ایمیل',
      'تغییر شماره موبایل',
      'حذف یا اصلاح کد ملی',
      'تغییر نام',
    ],
  },
  {
    key: 'crm',
    titleKey: 'ORBEX.MACROS.CATEGORIES.CRM',
    icon: 'i-lucide-users-round',
    keywords: ['مدیر حساب - '],
    order: [
      'موجودی صفر',
      'بونوس',
      'سرور مجازی',
      'حذف حساب',
      'کپی ترید',
      'تغییر ایمیل',
      'تغییر شماره موبایل',
    ],
  },
  {
    key: 'other',
    titleKey: 'ORBEX.MACROS.CATEGORIES.OTHER',
    icon: 'i-lucide-layout-grid',
    keywords: ['موارد دیگر - '],
    order: ['سایر'],
  },
];

export const macroPanelKeys = {
  searchPlaceholder: 'ORBEX.MACROS.SEARCH_PLACEHOLDER',
  noResults: 'ORBEX.MACROS.NO_RESULTS',
};
